<template>
  <section>
    <div class="page">
      <div>
        <h2>
          Problems with sending and receiving messages
        </h2>
        <p>
          The most common reason why you can't send or receive ToTok messages is
          a bad Internet connection. Learn how to
          <a href="https://totok.ai/faq/ios/20801"
            >troubleshoot connection issues</a
          >.
        </p>
        <p>
          If you're sure your phone is connected to the Internet, there are a
          few reasons why ToTok messages aren't going through:
        </p>
        <ul>
          <li>
            Your phone needs to be restarted or turned off and on.
          </li>
          <li>
            The contact you're messaging has blocked your number. Find out more
            in <a href="https://totok.ai/faq/ios/20704">this article</a> .
          </li>
          <li>
            You haven't completed the initial verification process. Learn about
            <a href="https://totok.ai/faq/ios/20201">verification</a>
            .
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
